module.exports = __webpack_public_path__ + "img/sloat-cq9.312d5a43.jpg";